import { ESTADO_CESION_ACEPTACION } from "api/Types/EstadoCesionAceptacion"
import { TFunction } from "i18next"

export const OPTIONS_ESTADO_ACEPTACION = (t: TFunction) => [
  {
    label: `${t("validaciones.modal.statusAceptacion.aceptLabel")}`,
    value: ESTADO_CESION_ACEPTACION.ACEPTADA,
  },
  {
    label: `${t("validaciones.modal.statusAceptacion.rejectLabel")}`,
    value: ESTADO_CESION_ACEPTACION.RECHAZADA,
  },
]

export const PLAZOS_VALUES = {
  ONE_MONTH: 30,
  TWO_MONTHS: 60,
  THREE_MONTHS: 90,
  FOUR_MONTHS: 120,
  FIVE_MONTHS: 150,
  SIX_MONTHS: 180,
  SEVEN_MONTHS: 210,
  EIGHT_MONTHS: 240,
}

export const OPTIONS_PLAZO_PAGO = (t: TFunction) => [
  {
    label: `${PLAZOS_VALUES.ONE_MONTH} ${t("validaciones.modal.daysLabel")}`,
    value: PLAZOS_VALUES.ONE_MONTH,
  },
  {
    label: `${PLAZOS_VALUES.TWO_MONTHS} ${t("validaciones.modal.daysLabel")}`,
    value: PLAZOS_VALUES.TWO_MONTHS,
  },
  {
    label: `${PLAZOS_VALUES.THREE_MONTHS} ${t("validaciones.modal.daysLabel")}`,
    value: PLAZOS_VALUES.THREE_MONTHS,
  },
  {
    label: `${PLAZOS_VALUES.FOUR_MONTHS} ${t("validaciones.modal.daysLabel")}`,
    value: PLAZOS_VALUES.FOUR_MONTHS,
  },
  {
    label: `${PLAZOS_VALUES.FIVE_MONTHS} ${t("validaciones.modal.daysLabel")}`,
    value: PLAZOS_VALUES.FIVE_MONTHS,
  },
  {
    label: `${PLAZOS_VALUES.SIX_MONTHS} ${t("validaciones.modal.daysLabel")}`,
    value: PLAZOS_VALUES.SIX_MONTHS,
  },
  {
    label: `${PLAZOS_VALUES.SEVEN_MONTHS} ${t("validaciones.modal.daysLabel")}`,
    value: PLAZOS_VALUES.SEVEN_MONTHS,
  },
  {
    label: `${PLAZOS_VALUES.EIGHT_MONTHS} ${t("validaciones.modal.daysLabel")}`,
    value: PLAZOS_VALUES.EIGHT_MONTHS,
  },
]

export const TIPO_CESION = {
  FUTURO: 1,
}
